export enum ChoiceStyle {
    Dropdown = "dropdown",
    Inline = "inline",
    Chips = "chips",
    RadioButtons = "radio",
}
